import { render, staticRenderFns } from "./PopupRiskDksteelDecision.vue?vue&type=template&id=613824bc&scoped=true"
import script from "./PopupRiskDksteelDecision.vue?vue&type=script&lang=js"
export * from "./PopupRiskDksteelDecision.vue?vue&type=script&lang=js"
import style0 from "./PopupRiskDksteelDecision.vue?vue&type=style&index=0&id=613824bc&prod&lang=scss&scoped=true"
import style1 from "./PopupRiskDksteelDecision.vue?vue&type=style&index=1&id=613824bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613824bc",
  null
  
)

export default component.exports